import React, { useRef } from "react";
import BusinessTabs from "./BusinessTabs";
import CheckPoint from "./CheckPoint";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

export const wrap = (min: number, max: number, v: number) => {
    const rangeSize = max - min;
    return ((((v - min) % rangeSize) + rangeSize) % rangeSize) + min;
};

const FeatureB = () => {
    const ref = useRef(null);
    const settings = {
        dots: true,
        autoplay: false,
        Speed: 5000,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 1,
        arrows: false
    };

    return (
        <>
            <BusinessTabs current="service-incubation" />

            <section className="bg-gray-50">
                <div className="container mx-auto max-w-6xl space-y-section px-5 py-section-lg xl:px-0">
                    <div
                        className="grid lg:grid-cols-2 lg:items-center lg:gap-8"
                        id="3"
                        ref={ref}
                    >
                        <div className="flex flex-col">
                            <h3 className="font-bold tracking-tight dark:text-gray-50 text-h1">
                                서비스 인큐베이션
                            </h3>
                            <div className="mt-8 space-y-8">
                                <CheckPoint
                                    description="창의적인 ICT융합 아이디어를 앱 또는 웹서비스로 현실화하는 서비스 인큐베이팅은 대학생 및 창업 초기 기업을 대상으로 진행하고 있습니다."
                                />
                                <CheckPoint
                                    description="안정적으로 서비스 개발에 전념할 수 있도록 개발실, 인력, 컨설팅을 지원합니다."
                                />
                            </div>
                        </div>
                        <div
                            aria-hidden="true"
                            className="img_slide_wrap mt-10 overflow-hidden lg:mt-0"
                        >
                            <Slider {...settings}>
                                <img
                                    src="/img/img_sub2-6.png"
                                    alt=""
                                    className="mx-auto "
                                />
                                <img
                                    src="/img/img_sub2-7.png"
                                    alt=""
                                    className="mx-auto "
                                />
                            </Slider>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default FeatureB;
